import React from "react";
import { capitalize } from "lodash";
import { useField, FieldConfig } from "formik";
import {
  FormControl,
  TextField,
  TextFieldProps,
  Typography,
} from "@mui/material";
import { FieldError } from "./FieldError";

interface IFieldInputProps extends FieldConfig {
  label?: string;
  as?: any;
}

export function FieldText({
  name,
  label,
  ...props
}: IFieldInputProps & TextFieldProps) {
  const [field, meta] = useField(name);

  const isErrored = !!meta?.touched && !!meta?.error;
  return (
    <FormControl
      className="field-container"
      fullWidth={props.fullWidth}
      sx={{ textAlign: "left" }}
    >
      {label && (
        <Typography
          variant="body1"
          fontWeight="bold"
          marginBottom={1}
        >
          {label}
        </Typography>
      )}
      <TextField
        {...props}
        {...field}
        inputProps={{ sx: { paddingY: 1.5, ...props.inputProps } }}
        sx={{
          "& fieldset": { borderColor: isErrored ? "#f00" : "" },
        }}
      />
      {isErrored && <FieldError>{capitalize(meta.error)}</FieldError>}
    </FormControl>
  );
}
